<template lang="pug">
el-dialog.modal-inibir-restricoes(
    :visible.sync='mostrarDialog',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :show-close='false',
    width='30%'
)
    div(
        style='background: white; height: auto; padding: 20px; border-radius: 5px'
    )
        section.mb-4.template(slot='title')
            .modal-inibir-restricoes__header
                .modal-inibir-restricoes__header--icon
                    i.el-icon-warning-outline
                .modal-inibir-restricoes__header--title
                    | Inibir restrições

        section.modal-inibir-restricoes__body
            .modal-inibir-restricoes__body--descricao
                div(v-html='identificarLabelRestricoes()')

                .modal-inibir-restricoes__body--form
                    el-form(
                        label-position='top',
                        ref='formInibirRestricoes',
                        :model='payload',
                        :rules='formRules'
                    )
                        el-form-item(
                            prop='operacoes',
                            v-if='this.operacoes.length > 0'
                        )
                            template(slot='label')
                                span.label Selecionar operações
                            el-select.w-100(
                                v-model='payload.idsOperacoes',
                                multiple,
                                filterable,
                                collapse-tags,
                                placeholder='Clique para selecionar',
                                value-key='id'
                            )
                                el-option(
                                    v-for='operacao in operacoes',
                                    :key='operacao.id',
                                    :label='montarLabelOpcoes(operacao)',
                                    :value='operacao.id'
                                )

                        el-form-item(prop='justificativa')
                            template(slot='label')
                                span.label.campo_obrigatorio Selecione a justificativa
                            el-select.w-100(
                                v-model='payload.idJustificativa',
                                placeholder='Clique para selecionar',
                                value-key='id'
                            )
                                el-option(
                                    v-for='justificativa in justificativas',
                                    :key='justificativa.id',
                                    :label='justificativa.nome',
                                    :value='justificativa.id'
                                )

                        el-form-item(prop='descricao')
                            template(slot='label')
                                span.label Descrição

                            el-input(
                                v-model='payload.descricaoJustificativa',
                                type='textarea',
                                :rows='3',
                                placeholder='Digite aqui sua justificativa...'
                            )

        section.modal-inibir-restricoes__action
            el-button(size='mini', @click='fechar')
                | Voltar
            el-button(type='primary', size='mini', @click='inibirRestricao')
                | Continuar
</template>

<script>
import OperacaoMonitoramentoService from '@/services/OperacaoMonitoramentoService';
import DiagnosticoSociambientealRepresentante from '@/components/ModalDiagnosticoSocioambientalRepresentante.vue';

export default {
    name: 'ModalInibirRestricoes',
    emits: ['atualizar-restricao-inibido'],
    components: { DiagnosticoSociambientealRepresentante },

    props: {
        idOperacao: {
            required: true
        },
        codigoCamada: {
            type: String,
            required: true
        },
        codigoRestricao: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            mostrarDialog: false,
            payload: {
                codigoCamada: null,
                codigoRestricao: null,
                idsOperacoes: [],
                idJustificativa: null,
                descricaoJustificativa: null,
                acao: 'INSERIR'
            },
            formRules: {
                justificativa: [
                    { validator: this.checkRuleJustificativa, trigger: 'blur' }
                ]
            },
            operacoes: [],
            justificativas: []
        };
    },

    watch: {
        mostrarDialog: function (value) {
            if (value) {
                this.payload.codigoCamada = this.codigoCamada;
                this.payload.codigoRestricao = this.codigoRestricao;
                this.buscarOperacoesInibicao();
                this.buscarJustificativas();
            }
        }
    },

    methods: {
        async buscarOperacoesInibicao() {
            await OperacaoMonitoramentoService.buscarOperacoesInibicao({
                idOperacao: this.idOperacao,
                codigoRestricao: this.codigoRestricao,
                acao: 'INSERIR'
            })
                .then(({ data }) => {
                    this.operacoes = data.itens;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar as operações para inibição'
                    })
                );
        },
        async buscarJustificativas() {
            await OperacaoMonitoramentoService.buscarJustificativasInibirRestricoes()
                .then(({ data }) => {
                    this.justificativas = data.itens;
                })
                .catch(() =>
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar as justificativas para inibição'
                    })
                );
        },
        checkRuleJustificativa(rule, value, callback) {
            if (this.payload.idJustificativa === null) {
                return callback(
                    new Error('Escolha pelo menos uma justificativa')
                );
            }
            callback();
        },
        async inibirRestricao() {
            const formValidado = await this.$refs.formInibirRestricoes
                .validate()
                .then(value => value)
                .catch(() => false);

            if (!formValidado) return;

            this.payload.idsOperacoes.push(this.idOperacao);
            await OperacaoMonitoramentoService.inibirRestricao(this.payload)
                .then(({ data }) => {
                    this.$notify.success({
                        message: data,
                        duration: 10000
                    });
                    this.fechar();
                    this.$emit('atualizar-restricao-inibido');
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi possível inibir a restrição. ' +
                            'Se o problema persistir, entre em contato com suporte.'
                    });
                    this.fechar();
                })
                .finally(() => {
                    this.payload = {
                        codigoCamada: null,
                        codigoRestricao: null,
                        idsOperacoes: [],
                        idJustificativa: null,
                        descricaoJustificativa: null,
                        acao: 'INSERIR'
                    };
                });
        },
        identificarLabelRestricoes() {
            if (this.operacoes.length > 0) {
                return `<span>Você está prestes a inibir esta restrição! Ela também se encontra presente
                em ${this.operacoes.length} operação(ões) e você também pode inibi-las diretamente daqui.
                Siga as etapas para continuar.</span>`;
            } else {
                return '<span>Você está prestes a inibir esta restrição. Siga as etapas para continuar.</span>';
            }
        },
        montarLabelOpcoes(operacao) {
            return (
                'ID: ' +
                operacao.identificador +
                ' | Nome: ' +
                (operacao.nome ? operacao.nome : '--')
            );
        },
        fechar() {
            this.mostrarDialog = false;
        }
    }
};
</script>

<style lang="scss">
.modal-inibir-restricoes {
    display: flex;

    .modal-inibir-restricoes__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .modal-inibir-restricoes__header--icon {
            margin-right: 10px;
            font-size: 20px;
            color: #fec556;
        }

        .modal-inibir-restricoes__header--title {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .modal-inibir-restricoes__body {
        width: 100%;

        .modal-inibir-restricoes__body--descricao {
            font-weight: 500;
            font-size: 14px;
            word-break: break-word;
        }
    }

    .modal-inibir-restricoes__action {
        height: 50px;
        border-top: solid 2px #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }

    .el-dialog {
        background: none !important;
    }

    .el-dialog__body {
        padding: 20px;
    }

    .el-form-item__label {
        padding: 0 !important;
        margin-top: 5px !important;
    }

    .campo_obrigatorio::after {
        content: '*';
        color: red;
    }
}
</style>
